export default "__VITE_ASSET__DOdP8$cE__"